export const HOME_FAQ = [
  { q: "What is MENAGroupFX?", a: "MENAGroupFX is an Introducing Broker that connects traders with selected third-party brokerage partners, while providing an additional layer of support, education and market intelligence." },
  { q: "Is MENAGroupFX a broker?", a: "No. MENAGroupFX operates as an Introducing Broker and/or referral partner. Brokerage services, execution and account administration are provided by the relevant third-party broker." },
  { q: "Where is my trading account held?", a: "Your trading account is opened and held directly with the brokerage provider you select, under that broker's terms and regulatory framework." },
  { q: "Does MENAGroupFX hold client funds?", a: "No. Unless expressly stated and supported by applicable regulatory authorisation, MENAGroupFX does not hold client trading funds. Deposits and withdrawals are handled by the broker." },
  { q: "How do I open an account?", a: "Explore our broker partners, choose a provider that fits your requirements, then complete registration and verification directly with that broker." },
  { q: "Which trading platforms are available?", a: "Platforms such as MetaTrader 5, MetaTrader 4, web and mobile trading may be available depending on the brokerage partner." },
  { q: "Can I become an Introducing Broker?", a: "Yes. We welcome applications from IBs, affiliates, educators and communities. Visit our Become a Partner page to apply." },
  { q: "Is trading risky?", a: "Yes. Trading leveraged instruments involves a high level of risk and may result in the loss of your invested capital. Ensure you understand the risks before trading." },
];

export const FAQ_GROUPS = [
  { title: "General", items: HOME_FAQ.slice(0, 2) },
  {
    title: "Accounts",
    items: [
      { q: "Where is my trading account held?", a: "Directly with the selected brokerage provider under that broker's terms and regulatory framework." },
      { q: "What account types are available?", a: "Account types such as Standard, Raw Spread, Professional, Islamic/Swap-Free and Corporate may be offered by partners, subject to eligibility." },
    ],
  },
  {
    title: "Trading",
    items: [
      { q: "Which markets can I access?", a: "Forex, commodities, indices and shares may be available depending on the brokerage partner and your jurisdiction." },
      { q: "Are spreads and leverage fixed?", a: "No. Spreads, commissions and leverage are set by the brokerage partner and vary by account type and jurisdiction." },
    ],
  },
  {
    title: "Broker Partners",
    items: [
      { q: "How are broker partners selected?", a: "We consider factors including regulatory status, technology, market access, client support and operational capabilities." },
      { q: "Are the listed brokers real?", a: "The current listings are clearly-marked placeholders. Verified broker information is published by an administrator through the admin panel." },
    ],
  },
  {
    title: "Platforms",
    items: [
      { q: "Does MENAGroupFX own the platforms?", a: "No. Trading platforms such as MetaTrader are provided by the brokerage partners, not by MENAGroupFX." },
      { q: "Can I trade on mobile?", a: "Mobile trading may be available depending on the platforms offered by your chosen broker." },
    ],
  },
  {
    title: "Partnerships",
    items: [
      { q: "Can I become an Introducing Broker?", a: "Yes. Apply through the Become a Partner page. Our team will review your application." },
      { q: "How does partner remuneration work?", a: "Commercial structures vary by relationship. MENAGroupFX may receive remuneration from brokers for qualifying activity." },
    ],
  },
  {
    title: "Risk",
    items: [
      { q: "Is trading risky?", a: "Yes. Trading leveraged instruments involves a high level of risk and may result in the loss of your invested capital." },
      { q: "Are past results a guide to future performance?", a: "No. Past performance is not indicative of future results." },
    ],
  },
];

export const MARKET_CONTENT = {
  forex: {
    overline: "Forex",
    title: "Trade the Global Currency Markets",
    description: "The foreign exchange market is the largest and most liquid financial market in the world, operating 24 hours a day, five days a week.",
    sections: [
      { h: "What is Forex?", p: "Forex (foreign exchange) is the market in which currencies are traded against one another. Prices move as global supply and demand shift in response to economic data, interest rates, and geopolitical events." },
      { h: "Currency Pairs", p: "Currencies are always quoted in pairs — the base currency and the quote currency. The price reflects how much of the quote currency is needed to buy one unit of the base currency." },
      { h: "Major, Minor & Exotic Pairs", p: "Major pairs include the most traded currencies against the US dollar (e.g. EUR/USD, GBP/USD, USD/JPY). Minor pairs exclude the dollar (e.g. EUR/GBP). Exotic pairs combine a major currency with an emerging-market currency and can carry wider spreads." },
      { h: "Spreads, Pips & Leverage", p: "The spread is the difference between the bid and ask price. A pip is the smallest standard price increment. Leverage allows larger exposure with a smaller deposit but magnifies both gains and losses — always managed by the brokerage partner." },
      { h: "Trading Hours & Risk", p: "The forex market trades continuously across global sessions from Sydney to New York. Leveraged forex trading carries a high level of risk and may not be suitable for all investors." },
    ],
    instruments: ["EUR/USD", "GBP/USD", "USD/JPY", "AUD/USD", "USD/CHF", "EUR/GBP"],
    cta: "Explore Brokerage Options",
  },
  commodities: {
    overline: "Commodities",
    title: "Access Global Commodity Markets",
    description: "Commodities offer diversification and exposure to global economic and supply-demand dynamics across metals and energy.",
    sections: [
      { h: "Gold (XAU/USD)", p: "Gold is widely regarded as a safe-haven asset. Its price is influenced by real interest rates, the US dollar, inflation expectations and risk sentiment." },
      { h: "Silver", p: "Silver combines safe-haven demand with significant industrial usage, which can make it more volatile than gold." },
      { h: "Oil", p: "Crude oil prices respond to global supply decisions, inventories, demand cycles and geopolitical developments." },
      { h: "Other Commodities", p: "Additional energy and metal products may be available depending on the brokerage partner and jurisdiction." },
      { h: "Market Drivers", p: "Commodity markets are driven by macroeconomic data, currency movements, seasonal demand and geopolitical events. Trading commodities via CFDs carries a high level of risk." },
    ],
    instruments: ["XAU/USD", "XAG/USD", "Oil (WTI)", "Oil (Brent)", "Natural Gas"],
    cta: "Explore Commodity Trading",
  },
  indices: {
    overline: "Indices",
    title: "Follow the World's Major Equity Markets",
    description: "Index instruments track the performance of a basket of leading companies, offering broad exposure to an economy or sector.",
    sections: [
      { h: "What are Indices?", p: "A stock index measures the performance of a group of shares. Index instruments allow traders to take a view on an entire market rather than a single company." },
      { h: "Major Global Indices", p: "Instruments linked to indices such as the S&P 500, Nasdaq 100, Dow Jones, DAX, FTSE 100, CAC 40, Nikkei 225 and Hang Seng may be available where configured by the brokerage partner." },
      { h: "What Moves Indices", p: "Index prices respond to corporate earnings, monetary policy, economic data and broad market sentiment." },
      { h: "Availability", p: "Specific index instruments are only available where offered by a configured brokerage partner. MENAGroupFX does not claim availability of any instrument." },
    ],
    instruments: ["US 500", "US 100", "US 30", "GER 40", "UK 100", "JP 225"],
    cta: "Explore Index Trading",
  },
  shares: {
    overline: "Shares",
    title: "Trade International Company Instruments",
    description: "Access trading opportunities linked to shares of international companies through instruments offered by brokerage partners.",
    sections: [
      { h: "Share CFDs vs Owning Shares", p: "Many brokers offer share CFDs — derivative products that track a share price without transferring ownership of the underlying share. This is different from buying and holding the actual shares." },
      { h: "Why Trade Share Instruments", p: "Share instruments can offer flexibility such as the ability to go long or short and to use leverage, subject to the broker's terms." },
      { h: "Key Considerations", p: "Derivative products carry a high level of risk. Dividends, corporate actions and financing costs are handled according to the broker's policies." },
      { h: "Availability", p: "The range of available shares depends on what the partner broker actually provides in your jurisdiction." },
    ],
    instruments: ["Technology", "Financials", "Energy", "Consumer", "Healthcare"],
    cta: "Explore Share Instruments",
  },
};

export const HOME_FAQ_AR = [
  { q: "ما هي MENAGroupFX؟", a: "MENAGroupFX وسيط معرّف يربط المتداولين بوسطاء خارجيين مختارين، مع توفير طبقة إضافية من الدعم والتعليم وذكاء السوق." },
  { q: "هل MENAGroupFX وسيط؟", a: "لا. تعمل MENAGroupFX كوسيط معرّف و/أو شريك إحالة. تُقدَّم خدمات الوساطة والتنفيذ وإدارة الحساب من قبل الوسيط الخارجي المعني." },
  { q: "أين يُحفظ حساب التداول الخاص بي؟", a: "يُفتح حسابك ويُحفظ مباشرة لدى مزود الوساطة الذي تختاره، وفق شروطه وإطاره التنظيمي." },
  { q: "هل تحتفظ MENAGroupFX بأموال العملاء؟", a: "لا. ما لم يُذكر خلاف ذلك صراحةً وبدعم من ترخيص تنظيمي، لا تحتفظ MENAGroupFX بأموال تداول العملاء. تُدار الإيداعات والسحوبات عبر الوسيط." },
  { q: "كيف أفتح حساباً؟", a: "استكشف وسطاءنا الشركاء، اختر مزوداً يناسب متطلباتك، ثم أكمل التسجيل والتحقق مباشرة مع ذلك الوسيط." },
  { q: "ما المنصات المتاحة؟", a: "قد تتوفر منصات مثل MetaTrader 5 وMetaTrader 4 والويب والجوال حسب الوسيط الشريك." },
  { q: "هل يمكنني أن أصبح وسيطاً معرّفاً؟", a: "نعم. نرحب بطلبات الوسطاء المعرّفين والمسوّقين والمعلّمين والمجتمعات. زر صفحة كن شريكاً للتقديم." },
  { q: "هل التداول محفوف بالمخاطر؟", a: "نعم. ينطوي تداول الأدوات ذات الرافعة على مخاطر عالية وقد يؤدي إلى خسارة رأس مالك المستثمر. تأكد من فهم المخاطر قبل التداول." },
];

export const FAQ_GROUPS_AR = [
  { title: "عام", items: HOME_FAQ_AR.slice(0, 2) },
  { title: "الحسابات", items: [
    { q: "أين يُحفظ حساب التداول الخاص بي؟", a: "مباشرة لدى مزود الوساطة المختار وفق شروطه وإطاره التنظيمي." },
    { q: "ما أنواع الحسابات المتاحة؟", a: "قد يقدم الشركاء أنواعاً مثل القياسي والفارق الخام والاحترافي والإسلامي والمؤسسي، حسب الأهلية." },
  ]},
  { title: "التداول", items: [
    { q: "ما الأسواق التي يمكنني الوصول إليها؟", a: "قد تتوفر الفوركس والسلع والمؤشرات والأسهم حسب الوسيط الشريك وولايتك القضائية." },
    { q: "هل الفروقات والرافعة ثابتة؟", a: "لا. تُحدَّد الفروقات والعمولات والرافعة من قبل الوسيط الشريك وتختلف حسب نوع الحساب والولاية." },
  ]},
  { title: "الوسطاء الشركاء", items: [
    { q: "كيف يتم اختيار الوسطاء الشركاء؟", a: "نراعي عوامل تشمل الوضع التنظيمي والتقنية والوصول للأسواق ودعم العملاء والقدرات التشغيلية." },
    { q: "هل الوسطاء المدرجون حقيقيون؟", a: "القوائم الحالية مبدئية بوضوح. تُنشر معلومات الوسطاء الموثوقة عبر لوحة الإدارة." },
  ]},
  { title: "المنصات", items: [
    { q: "هل تمتلك MENAGroupFX المنصات؟", a: "لا. تُقدَّم منصات مثل MetaTrader من قبل الوسطاء الشركاء وليس من MENAGroupFX." },
    { q: "هل يمكنني التداول عبر الجوال؟", a: "قد يتوفر التداول عبر الجوال حسب المنصات التي يقدمها وسيطك المختار." },
  ]},
  { title: "الشراكات", items: [
    { q: "هل يمكنني أن أصبح وسيطاً معرّفاً؟", a: "نعم. قدّم عبر صفحة كن شريكاً وسيقوم فريقنا بمراجعة طلبك." },
    { q: "كيف تعمل عمولة الشركاء؟", a: "تختلف الهياكل التجارية حسب العلاقة. قد تتلقى MENAGroupFX عمولات من الوسطاء مقابل النشاط المؤهل." },
  ]},
  { title: "المخاطر", items: [
    { q: "هل التداول محفوف بالمخاطر؟", a: "نعم. ينطوي تداول الأدوات ذات الرافعة على مخاطر عالية وقد يؤدي لخسارة رأس مالك المستثمر." },
    { q: "هل الأداء السابق دليل على المستقبل؟", a: "لا. الأداء السابق ليس مؤشراً على النتائج المستقبلية." },
  ]},
];

export const MARKET_CONTENT_AR = {
  forex: {
    overline: "الفوركس", title: "تداول أسواق العملات العالمية",
    description: "سوق الفوركس هو أكبر وأكثر الأسواق المالية سيولة في العالم، ويعمل 24 ساعة يومياً خمسة أيام في الأسبوع.",
    sections: [
      { h: "ما هو الفوركس؟", p: "الفوركس هو سوق تُتداول فيه العملات مقابل بعضها. تتحرك الأسعار مع تغير العرض والطلب العالمي استجابةً للبيانات الاقتصادية وأسعار الفائدة والأحداث الجيوسياسية." },
      { h: "أزواج العملات", p: "تُقتبس العملات دائماً في أزواج — العملة الأساس وعملة التسعير. يعكس السعر كمية عملة التسعير اللازمة لشراء وحدة من العملة الأساس." },
      { h: "الأزواج الرئيسية والثانوية والنادرة", p: "تشمل الأزواج الرئيسية أكثر العملات تداولاً مقابل الدولار الأمريكي. الأزواج الثانوية تستثني الدولار. الأزواج النادرة تجمع عملة رئيسية بعملة سوق ناشئة وقد تحمل فروقات أوسع." },
      { h: "الفروقات والنقاط والرافعة", p: "الفارق هو الفرق بين سعري العرض والطلب. النقطة أصغر وحدة قياسية لحركة السعر. تتيح الرافعة تعرضاً أكبر بإيداع أصغر لكنها تضخّم الأرباح والخسائر — وتُدار من قبل الوسيط الشريك." },
      { h: "ساعات التداول والمخاطر", p: "يتداول الفوركس باستمرار عبر الجلسات العالمية. ينطوي تداول الفوركس ذي الرافعة على مخاطر عالية وقد لا يناسب جميع المستثمرين." },
    ],
    instruments: ["EUR/USD", "GBP/USD", "USD/JPY", "AUD/USD", "USD/CHF", "EUR/GBP"],
    cta: "استكشف خيارات الوساطة",
  },
  commodities: {
    overline: "السلع", title: "الوصول لأسواق السلع العالمية",
    description: "توفر السلع تنويعاً وتعرضاً لديناميكيات الاقتصاد العالمي والعرض والطلب عبر المعادن والطاقة.",
    sections: [
      { h: "الذهب (XAU/USD)", p: "يُعد الذهب أصلاً ملاذاً آمناً. يتأثر سعره بأسعار الفائدة الحقيقية والدولار وتوقعات التضخم ومعنويات المخاطرة." },
      { h: "الفضة", p: "تجمع الفضة بين الطلب كملاذ آمن والاستخدام الصناعي الكبير، ما قد يجعلها أكثر تقلباً من الذهب." },
      { h: "النفط", p: "تستجيب أسعار النفط الخام لقرارات العرض العالمية والمخزونات ودورات الطلب والتطورات الجيوسياسية." },
      { h: "سلع أخرى", p: "قد تتوفر منتجات طاقة ومعادن إضافية حسب الوسيط الشريك والولاية القضائية." },
      { h: "محركات السوق", p: "تتحرك أسواق السلع بالبيانات الاقتصادية وحركات العملات والطلب الموسمي والأحداث الجيوسياسية. ينطوي تداول السلع على مخاطر عالية." },
    ],
    instruments: ["XAU/USD", "XAG/USD", "Oil (WTI)", "Oil (Brent)", "Natural Gas"],
    cta: "استكشف تداول السلع",
  },
  indices: {
    overline: "المؤشرات", title: "تابع أهم أسواق الأسهم العالمية",
    description: "تتبع أدوات المؤشرات أداء سلة من الشركات الرائدة، ما يوفر تعرضاً واسعاً لاقتصاد أو قطاع.",
    sections: [
      { h: "ما هي المؤشرات؟", p: "يقيس مؤشر الأسهم أداء مجموعة من الأسهم. تتيح أدوات المؤشرات اتخاذ موقف تجاه سوق كامل بدل شركة واحدة." },
      { h: "أهم المؤشرات العالمية", p: "قد تتوفر أدوات مرتبطة بمؤشرات مثل S&P 500 وNasdaq 100 وDow Jones وDAX وFTSE 100 وNikkei 225 حيثما هيّأها الوسيط الشريك." },
      { h: "ما الذي يحرّك المؤشرات", p: "تستجيب أسعار المؤشرات لأرباح الشركات والسياسة النقدية والبيانات الاقتصادية ومعنويات السوق." },
      { h: "التوفر", p: "تتوفر أدوات مؤشرات محددة فقط حيثما يقدمها وسيط شريك مهيّأ. لا تدّعي MENAGroupFX توفر أي أداة." },
    ],
    instruments: ["US 500", "US 100", "US 30", "GER 40", "UK 100", "JP 225"],
    cta: "استكشف تداول المؤشرات",
  },
  shares: {
    overline: "الأسهم", title: "تداول أدوات الشركات الدولية",
    description: "الوصول لفرص تداول مرتبطة بأسهم شركات دولية عبر أدوات يقدمها الوسطاء الشركاء.",
    sections: [
      { h: "عقود الأسهم مقابل امتلاك الأسهم", p: "يقدم كثير من الوسطاء عقود أسهم مقابل الفروقات — منتجات مشتقة تتبع سعر السهم دون نقل ملكيته. يختلف هذا عن شراء الأسهم الفعلية والاحتفاظ بها." },
      { h: "لماذا تداول أدوات الأسهم", p: "قد توفر أدوات الأسهم مرونة مثل البيع على المكشوف واستخدام الرافعة، وفق شروط الوسيط." },
      { h: "اعتبارات مهمة", p: "تحمل المنتجات المشتقة مخاطر عالية. تُعالج الأرباح والإجراءات المؤسسية وتكاليف التمويل وفق سياسات الوسيط." },
      { h: "التوفر", p: "يعتمد نطاق الأسهم المتاحة على ما يقدمه الوسيط الشريك فعلياً في ولايتك القضائية." },
    ],
    instruments: ["Technology", "Financials", "Energy", "Consumer", "Healthcare"],
    cta: "استكشف أدوات الأسهم",
  },
};
